var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m272,416c-8.8,0-16,7.2-16,16v16c0,17.67-14.33,32-32,32H64c-17.67,0-32-14.33-32-32V192c0-17.67,14.33-32,32-32h112c8.8,0,16-7.2,16-16s-7.2-16-16-16H63.99C28.64,128,0,156.65,0,192v256c0,35.3,28.66,64,64.01,64h160c35.35,0,64-28.65,64-64v-16c0-8.8-7.2-16-16-16ZM502.6,86.63L425.35,9.38c-5.95-6.01-14.15-9.38-22.65-9.38h-114.7c-35.3,0-64,28.65-64,64v256c0,35.35,28.65,64,64,64h160c35.35,0,64-28.65,64-64V109.3c0-8.5-3.4-16.67-9.4-22.67Zm-86.6-41.38l50.7,50.75h-50.7v-50.75Zm64,274.75c0,17.67-14.33,32-32,32h-160c-17.67,0-32-14.33-32-32V64c0-17.67,14.33-32,32-32h96v64c0,17.67,14.33,32,32,32h64v192Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c920657ab42b87e26928523d0cd077b5.svg";
export { ForwardRef as ReactComponent };